import { render, staticRenderFns } from "./ConsumoApi.vue?vue&type=template&id=75ca60ec&"
import script from "./ConsumoApi.vue?vue&type=script&lang=js&"
export * from "./ConsumoApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports